import React from 'react';
import { useTranslation } from 'react-i18next';
import './ProgressBar.css';

interface ProgressBarProps {
  progress: number;
  currentStep: number;
  totalSteps: number;
  queueProgress?: { current: number; total: number };
}

export const ProgressBar: React.FC<ProgressBarProps> = ({ progress, currentStep, totalSteps, queueProgress }) => {
  const { t } = useTranslation();
  return (
    <div className="progress-bar">
      <div className="progress-bar__track">
        <div 
          className="progress-bar__fill"
          style={{ width: `${progress}%` }}
        />
      </div>
      <div className="progress-bar__label">
        {queueProgress ? (
          <>
            <span style={{ fontWeight: '600', color: 'var(--color-primary, #007aff)' }}>
              {t('transaction.flow.transactionOf', { current: queueProgress.current, total: queueProgress.total })}
            </span>
            <span style={{ margin: '0 8px', color: 'var(--color-text-secondary, #999)' }}>•</span>
            <span>{t('transaction.flow.stepOf', { current: currentStep, total: totalSteps })}</span>
          </>
        ) : (
          <>{t('transaction.flow.stepOf', { current: currentStep, total: totalSteps })}</>
        )}
      </div>
    </div>
  );
};

